import React, { useEffect } from "react";
import { FiMessageSquare } from "react-icons/fi";

type Props = { unread?: number; onOpen: () => void };

const ChatLauncher: React.FC<Props> = ({ unread = 0, onOpen }) => {

  return (
    <button
      onClick={onOpen}
      className="fixed bottom-5 left-5 z-[1000] rounded-full shadow-xl bg-blue-600 text-white w-14 h-14 flex items-center justify-center"
      aria-label="Open chat"
    >
      <FiMessageSquare className="text-2xl" />
      {/* Badge is always in DOM, only visibility changes with opacity/scale */}
      <span
        className={`absolute -top-1 -right-1 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-red-600 text-white text-xs font-semibold px-2 py-0.5 transition-all duration-150 ${
          unread > 0
            ? "opacity-100 scale-100"
            : "opacity-0 scale-0 pointer-events-none"
        }`}
      >
        {unread}
      </span>
    </button>
  );
};

export default ChatLauncher;
